<template>
  <v-layout column align-end class="fab-container" v-if="isShow || isLogin">
    <v-speed-dial
      v-model="fab"
      bottom
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          class="fab-container__btn"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-apps
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        v-for="(item, index) in fabList"
        :key="index"
        fab
        dark
        small
        :color="item.color"
        @click="item.doFunction()"
        v-show="item.login === isLogin || item.env === env"
      >
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
      <div class="version-container">
        <div class="version-info">前端版本：{{ `V.${buildTime}` }}</div>
        <div class="version-info">後端版本：{{ apiVersion }}</div>
        <!-- 以後新增更多版本資訊也自動疊加 -->
      </div>
    </v-speed-dial>
    <v-btn
      v-scroll="onScroll"
      fab
      dark
      color="blue mb-4"
      @click="toTop"
      v-show="isLogin && goTopFab"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
    <QuickLogin ref="quickLogin"></QuickLogin>
    {{ipResult}}
  </v-layout>
</template>

<script>
import { getToken } from '@/utils/auth'; // eslint-disable-next-line
import QuickLogin from './Components/QuickLogin.vue';

export default {
  name: 'speed-dial',
  components: {
    QuickLogin,
  },
  data() {
    return {
      env: null,
      isShow: false,
      isLogin: false,
      status: false,
      fab: false,
      goTopFab: false,
      direction: 'top',
      hover: true,
      transition: 'slide-y-reverse-transition',
      fabList: [
        {
          icon: 'mdi-account-star', color: 'orange', doFunction: this.toggleQuickLogin, env: 'development',
        },
        {
          icon: 'mdi-printer', color: 'green', doFunction: this.doDefaultPrint, login: true,
        },
        {
          icon: 'mdi-heart', color: 'pink', doFunction: this.toggleMyFavorite, login: true,
        },
        {
          icon: 'mdi-translate', color: 'blue', doFunction: this.toggleLang, login: true,
        },
      ],
      ipResult: null,
      apiVersion: null,
    };
  },
  mounted() {
    this.env = process.env.VUE_APP_ENV;
    if (process.env.VUE_APP_ENV === 'development') {
      this.isShow = true;
    }

    if (getToken()) {
      this.isLogin = true;
    }

    this.doCheckInfo();
  },
  methods: {
    toggleQuickLogin() {
      this.$refs.quickLogin.openDialogHandler = true;
    },
    toggleMyFavorite() {
      this.$router.push({
        name: 'MyFavorite',
      });
    },
    toggleLang() {
      this.$i18n.locale = this.$i18n.locale === 'tw' ? 'en' : 'tw';
      localStorage.setItem('language', this.$i18n.locale);
      window.location.reload();
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.goTopFab = top > 20;
    },
    doCheckInfo() {
      return new Promise((resolve) => {
        $api.user.CheckInfo().then((res) => {
          const { code, result } = res;
          if (code === 200) {
            this.ipResult = res.data.result;
            this.apiVersion = res.data.apiVersion;
            resolve(result);
          }
        });
      });
    },
    doDefaultPrint() {
      const mainEl = document.querySelector('.main');
      if (!mainEl) {
        this.$swal.fire({
          title: '找不到要列印的內容',
          icon: 'warning',
          showConfirmButton: true,
        });
        return;
      }

      // Get HTML to print from element
      const prtHtml = document.querySelector('.main').innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      // eslint-disable-next-line no-restricted-syntax
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('print-preview.html', '_blank', 'left=0,top=0,width=0,height=0,toolbar=0,scrollbars=0,status=0 hide');

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
          <style>
            /* 遮罩樣式，讓它覆蓋在上面 */
            .print-mask {
              position: fixed;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #ffffff;
              z-index: 9999;
            }

            /* 印表機模式下隱藏遮罩 */
            @media print {
              .print-mask {
                display: none !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-mask"></div>
          <div class="v-application  v-application--is-ltr theme--light">
            <div class="v-application--wrap">     
              <div>        
                ${prtHtml}
              </div>
            </div>
          </div>
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.onload = () => {
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
      };
    },
  },
  computed: {
    buildTime() {
      return _dayjs(document.documentElement.dataset.buildTimestampUtc).format(
        'YYYYMMDD HHmmss',
      );
    },
  },
};

</script>

<style lang="scss" scoped>

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;

    &__btn {
      background-color: $systemColor1 !important;
    }
  }

  .version-container {
    position: absolute;
    right: 0;
    bottom: calc(100% - 12px);
    display: flex;
    flex-direction: column; /* 從上往下排列 */
    align-items: flex-end;  /* 靠右對齊 */
  }

  .version-info {
    background-color: rgba(0,0,0,0.7);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    margin-top: 8px;
  }
</style>
